var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _ellipse, _path12, _rect3, _ellipse2, _path13, _rect4, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSavannahThumbnail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#FFE5B4",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101 72V91C101 96.5228 96.5228 101 91 101H28.5C28.5 97.8 37.3 84 38.45 82.5C44.315 79 54.63 81.5 68.085 82.5C78.849 83.3 93.41 75.8333 101 72Z",
    fill: "#F1AE5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2219 58.4735C97.0736 57.3789 96.066 56.6118 94.9714 56.7601L93.6198 56.9433C92.5252 57.0916 91.7581 58.0992 91.9064 59.1937L91.9695 59.6595C92.1178 60.7541 91.3508 61.7616 90.2562 61.91L11.8302 72.5369C10.7356 72.6852 9.9685 73.6928 10.1168 74.7873L10.42 77.0249C10.5683 78.1195 11.5759 78.8866 12.6705 78.7383L96.412 67.3911C97.5065 67.2428 98.2736 66.2352 98.1253 65.1406L97.2219 58.4735Z",
    fill: "#D5D8DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0134 56.9345C96.9802 56.6899 96.755 56.5185 96.5104 56.5516C96.2657 56.5848 96.0943 56.8099 96.1274 57.0546L96.9993 63.4889C97.1476 64.5834 96.3805 65.591 95.286 65.7393L11.3344 77.115C10.8451 77.1813 10.5022 77.6316 10.5685 78.1209C10.6348 78.6102 11.0852 78.9531 11.5745 78.8868L96.412 67.3911C97.5065 67.2428 98.2736 66.2352 98.1253 65.1406L97.0134 56.9345Z",
    fill: "#818A98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0454 24.6852L54.7031 24.3251L65.1517 48.1703L62.4939 48.5304L52.0454 24.6852Z",
    fill: "#7B9A68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7324 33.1217L54.538 29.7605L61.2483 45.9926L32.0132 49.9541L29.7324 33.1217Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7324 33.1217L36.8197 32.1614L43.5301 48.3935L32.0132 49.9541L29.7324 33.1217Z",
    fill: "#A4D0DA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3169,
    y: 42.97,
    width: 16.9862,
    height: 10.7281,
    rx: 2,
    transform: "rotate(-7.71673 10.3169 42.97)",
    fill: "#C13925"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5854 44.9519C10.4371 43.8574 11.2042 42.8498 12.2988 42.7015L15.6324 42.2498L17.0729 52.8807L13.7393 53.3324C12.6447 53.4807 11.6372 52.7137 11.4889 51.6191L10.5854 44.9519Z",
    fill: "#892415"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9959 29.134C30.7372 27.2242 28.1925 26.7494 27.2624 28.4373L15.4467 49.8801C14.6536 51.3193 15.8385 53.0478 17.4669 52.8272L20.1131 52.4686C19.6057 51.8879 19.4304 51.0238 19.8385 50.2323L25.1725 39.887C26.0686 38.149 28.6695 38.5973 28.932 40.535L30.2123 49.9841C30.2672 50.3893 30.1967 50.7826 30.0305 51.1248L31.9226 50.8684C33.0172 50.7201 33.7843 49.7125 33.636 48.618L30.9959 29.134Z",
    fill: "#9DA4AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2471 50.9601L32.133 50.84C33.1115 50.7074 33.7973 49.8066 33.6647 48.8281L30.91 28.4984C30.7141 27.0525 29.0526 26.5266 28.0433 27.316L31.2471 50.9601Z",
    fill: "#67717E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5366 57.9099C10.1658 55.1735 12.0835 52.6546 14.82 52.2838L87.3003 42.4625C90.0367 42.0917 92.5556 44.0094 92.9264 46.7458L95.0161 62.1671L12.6262 73.3311L10.5366 57.9099Z",
    fill: "#7B9A68"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5366 57.9099C10.1658 55.1735 12.0835 52.6546 14.82 52.2838L26.9927 50.6344C28.9653 50.3671 30.9085 51.2954 31.9402 52.9978L41.8613 69.3697L12.6262 73.3311L10.5366 57.9099Z",
    fill: "#516F3F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2808,
    cy: 74.9542,
    r: 14.3041,
    transform: "rotate(-7.71673 27.2808 74.9542)",
    fill: "#3A3F46"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.6637,
    cy: 67.9917,
    r: 14.3041,
    transform: "rotate(-7.71673 78.6637 67.9917)",
    fill: "#3A3F46"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.281,
    cy: 74.9542,
    r: 7.15206,
    transform: "rotate(-7.71673 27.281 74.9542)",
    fill: "#C4C4C4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.6639,
    cy: 67.9916,
    r: 7.15206,
    transform: "rotate(-7.71673 78.6639 67.9916)",
    fill: "#C4C4C4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2813,
    cy: 74.9541,
    r: 5.36405,
    transform: "rotate(-7.71673 27.2813 74.9541)",
    fill: "#9DA4AF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.6642,
    cy: 67.9916,
    r: 5.36405,
    transform: "rotate(-7.71673 78.6642 67.9916)",
    fill: "#9DA4AF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.7724,
    cy: 48.9385,
    rx: 2.23502,
    ry: 5.36405,
    transform: "rotate(-7.71673 92.7724 48.9385)",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3295 48.9985C92.7273 51.9342 94.7159 54.0882 93.4927 54.254C92.2695 54.4197 90.9555 52.1743 90.5577 49.2386C90.1599 46.303 90.829 43.7888 92.0522 43.623C93.2754 43.4573 91.9317 46.0629 92.3295 48.9985Z",
    fill: "#5BABBD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.67578,
    y: 55.3273,
    width: 4.47004,
    height: 16.9862,
    rx: 2,
    transform: "rotate(-7.71673 5.67578 55.3273)",
    fill: "#3A3F46"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.0349,
    cy: 24.6455,
    rx: 3.12903,
    ry: 4.02304,
    transform: "rotate(-7.71673 29.0349 24.6455)",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.149 24.7656C28.4474 26.9673 31.2876 28.4001 29.5751 28.6321C27.8627 28.8642 26.2326 27.2674 25.9342 25.0657C25.6359 22.8639 26.7823 20.891 28.4947 20.6589C30.2072 20.4269 27.8507 22.5638 28.149 24.7656Z",
    fill: "#5BABBD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.3467,
    y: 51.5314,
    width: 8.04607,
    height: 2.68202,
    rx: 1.34101,
    transform: "rotate(-7.71673 40.3467 51.5314)",
    fill: "#505862"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 82V91C0 96.5228 4.47715 101 10 101H91C91 97.8 87.6333 94 85.95 92.5C77.365 89 73.73 91.5 54.035 92.5C38.279 93.3 11.11 85.8333 0 82Z",
    fill: "#D2A27A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSavannahThumbnail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SavannahThumbnail.e23e995550487e36b5cbbe54e74f6980.svg";